<template>
  <div class="menu-container">
    <div class="menu-wrap">
      <div class="menu tenken">
        <div class="title">点検者メニュー</div>
        <div class="items">
          <router-link :to="{ name: 'RojouTenken' }" class="item">
            <span class="btn btn-primary">路上巡回点検</span>
          </router-link>
          <router-link :to="{ name: 'RokaTenken' }" class="item">
            <span class="btn btn-primary">路下巡回点検</span>
          </router-link>
          <router-link :to="{ name: 'KoukashitaTenken' }" class="item">
            <span class="btn btn-primary">高架下巡回点検</span>
          </router-link>
        </div>
      </div>
      <div class="menu admin">
        <div class="title">管理者メニュー</div>
        <div class="items">
          <router-link :to="{ name: 'TenkenReport' }" class="item">
            <span class="btn btn-primary">報告書作成</span>
          </router-link>
          <router-link :to="{ name: 'HoshuReport' }" class="item">
            <span class="btn btn-primary">点検補修台帳出力</span>
          </router-link>
          <router-link :to="{ name: 'Search' }" class="item">
            <span class="btn btn-primary">検索</span>
          </router-link>
          <router-link :to="{ name: 'Admin' }" class="item" v-if="has_role_admin">
            <span class="btn btn-primary">コード管理</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'top',
  data() {
    return {
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
  },
  mixins: [],
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  margin: 30px;
}
.menu-wrap {
  display: inline-grid;
  grid-template-rows: auto auto;
  row-gap: 30px;
  justify-content: center;
  min-width: 100%;
}
.menu {
  padding: 20px 30px;
  background-color: #ffffff;
  .title {
    margin: 0 0 20px;
    font-size: 22px;
  }
  .items {
    display: flex;
    flex-wrap: wrap;
    .item {
      margin: 10px 30px;
      &:hover {
        text-decoration: none;
      }
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 210px;
        height: 70px;
        font-size: 20px;
      }
    }
  }
}
</style>
